/* Laavir nieuwsbriefaanmelding via Klaviyo (client subscriptions API).
   Elk formulier met [data-laavir-signup] meldt aan op de lijst uit data-list.
   Bij succes krijgt het formulier de class is-done; het element [data-signup-done] wordt zichtbaar. */
(function () {
  if (window.laavirSignupReady) return;
  window.laavirSignupReady = true;

  function subscribe(company, list, email, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      }),
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
    });
  }

  function remember() {
    try {
      localStorage.setItem('laavir_signup', 'done');
    } catch (e) {}
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-laavir-signup]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var error = form.querySelector('[data-signup-error]');
    var button = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (error) error.textContent = form.dataset.errorInvalid || 'Vul een geldig e-mailadres in.';
      input.focus();
      return;
    }
    if (error) error.textContent = '';
    button.disabled = true;
    subscribe(form.dataset.company, form.dataset.list, email, form.dataset.source || 'Laavir website')
      .then(function () {
        remember();
        form.classList.add('is-done');
        var done = form.closest('[data-signup-root]').querySelector('[data-signup-done]');
        if (done) {
          done.hidden = false;
          done.focus && done.focus();
        }
      })
      .catch(function () {
        if (error) error.textContent = form.dataset.errorGeneric || 'Er ging iets mis. Probeer het zo nog eens.';
      })
      .finally(function () {
        button.disabled = false;
      });
  });
})();
